import type { Language } from '@luna/i18n';
import { getFeatureConfig } from '@luna/feature-config';

import { getLanguageToSave } from './SettingsService';
import { querySettingsIfNeeded, updateSettings } from './useSettings';

export const saveSettingsLanguage = async (language: Language): Promise<void> => {
    if (!getFeatureConfig((featureConfig) => featureConfig.base.saveLanguageChangesToPresto)) {
        return;
    }

    const settings = await querySettingsIfNeeded();
    const languageToSave = getLanguageToSave(language) as Language;

    if (!settings || languageToSave === settings?.language) {
        return;
    }

    await updateSettings({ ...settings, language: languageToSave });
};

export const getSettingsLanguage = async (): Promise<Language | undefined> => {
    const settings = await querySettingsIfNeeded();
    return settings?.language;
};
